import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useHistoricalAccessToolContext } from "contexts/HistoricalAccessToolContext"
import MassSelection from "shared/MassSelection"
import HistoricalAccessToolLocationFilterDetailsSelectedFacilityDepartmentCheckbox from "./HistoricalAccessToolLocationFilterDetailsSelectedFacilityDepartmentCheckbox"

const HistoricalAccessToolLocationFilterDetailsSelectedFacilityDepartments = ({ className = "", selectedFacilityId }) => {
  const {
    addAllFacilityDepartmentsToReportableFieldLocationAnswerFilters,
    facilities,
    facilityDepartments,
    removeAllFacilityDepartmentsFromReportableFieldLocationAnswerFilters,
  } = useHistoricalAccessToolContext()

  const selectedFacility = facilities.find((facility) => facility.id === selectedFacilityId)

  const departments = facilityDepartments(selectedFacilityId)

  return (
    <div className={clsx("border border-lightgray-3 rounded p-4 mb-4", className)}>
      <p className="mb-4">{selectedFacility.name}</p>
      <MassSelection
        className="mb-4"
        deselectAll={() => removeAllFacilityDepartmentsFromReportableFieldLocationAnswerFilters(selectedFacilityId)}
        selectAll={() => addAllFacilityDepartmentsToReportableFieldLocationAnswerFilters(selectedFacilityId)}
      />
      {
        departments.map((department) => (
          <HistoricalAccessToolLocationFilterDetailsSelectedFacilityDepartmentCheckbox
            key={department.id}
            department={department}
          />
        ))
      }
    </div>
  )
}

HistoricalAccessToolLocationFilterDetailsSelectedFacilityDepartments.propTypes = {
  className: types.string,
  selectedFacilityId: types.number.isRequired,
}

export default HistoricalAccessToolLocationFilterDetailsSelectedFacilityDepartments
